<form [formGroup]="form">
  <div class="padding" fxLayout="column" fxLayoutGap="16px">
    <h2>Filter selectie</h2>
    <div fxFlex="auto" fxLayout="column">
      <div fxLayout="column">
        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0px" fxLayoutGap.gt-xs="22px">
          <mat-form-field #f2 [matTooltip]="getTooltipText(f2)" fxFlex="100" fxFlex.gt-xs="50">
            <mat-label>Startdatum & tijd van</mat-label>
            <input (dateChange)="setTime('created_at_start', $event)" matInput [mtxDatetimepicker]="createdAtStartPicker" readonly (click)="createdAtStartPicker.open()">
            <mtx-datetimepicker #createdAtStartPicker></mtx-datetimepicker>
            <mat-error *ngIf="formService.getFieldError('created_at_start')">
              {{ formService.getFieldError('created_at_start') }}
            </mat-error>
            <button (click)="clearValue('created_at_start');$event.stopImmediatePropagation();createdAtStartPicker._select(null)"
                    *ngIf="form.controls.created_at_start.value" aria-label="Clear" mat-icon-button
                    matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field #f2 [matTooltip]="getTooltipText(f2)" fxFlex="100" fxFlex.gt-xs="50">
            <mat-label>Startdatum & tijd tot</mat-label>
            <input (dateChange)="setTime('created_at_end', $event)" matInput [mtxDatetimepicker]="createdAtEndPicker" readonly (click)="createdAtEndPicker.open()">
            <mtx-datetimepicker #createdAtEndPicker></mtx-datetimepicker>
            <mat-error *ngIf="formService.getFieldError('created_at_end')">
              {{ formService.getFieldError('created_at_end') }}
            </mat-error>
            <button (click)="clearValue('created_at_end');$event.stopImmediatePropagation();createdAtEndPicker._select(null)"
                    *ngIf="form.controls.created_at_end.value" aria-label="Clear" mat-icon-button
                    matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0px" fxLayoutGap.gt-xs="22px">
          <mat-form-field #f3 [matTooltip]="getTooltipText(f3)" fxFlex="100" fxFlex.gt-xs="50">
            <mat-label>Einddatum & tijd van</mat-label>
            <input (dateChange)="setTime('closed_at_start', $event)" matInput [mtxDatetimepicker]="closedAtStartPicker" readonly (click)="closedAtStartPicker.open()">
            <mtx-datetimepicker #closedAtStartPicker></mtx-datetimepicker>
            <mat-error *ngIf="formService.getFieldError('closed_at_start')">
              {{ formService.getFieldError('closed_at_start') }}
            </mat-error>
            <button (click)="clearValue('closed_at_start');$event.stopImmediatePropagation();closedAtStartPicker._select(null)"
                    *ngIf="form.controls.closed_at_start.value" aria-label="Clear" mat-icon-button
                    matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field #f3 [matTooltip]="getTooltipText(f3)" fxFlex="100" fxFlex.gt-xs="50">
            <mat-label>Einddatum & tijd tot</mat-label>
            <input (dateChange)="setTime('closed_at_end', $event)" matInput [mtxDatetimepicker]="closedAtEndPicker" readonly (click)="closedAtEndPicker.open()">
            <mtx-datetimepicker #closedAtEndPicker></mtx-datetimepicker>
            <mat-error *ngIf="formService.getFieldError('closed_at_end')">
              {{ formService.getFieldError('closed_at_end') }}
            </mat-error>
            <button (click)="clearValue('closed_at_end');$event.stopImmediatePropagation();closedAtEndPicker._select(null)"
                    *ngIf="form.controls.closed_at_end.value" aria-label="Clear" mat-icon-button
                    matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <mat-form-field #f7 [matTooltip]="getTooltipText(f7)">
          <mat-label>Tegel</mat-label>
          <mat-select [formControl]="form.controls.tile_id" placeholder="Tegel">
            <mat-option *ngFor="let data of filters.tiles.data" [value]="data.id">
              {{ data.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formService.getFieldError('tile_id')">
            {{ formService.getFieldError('tile_id') }}
          </mat-error>
          <mat-spinner *ngIf="filters.tiles.isLoading" diameter="20"></mat-spinner>
          <button (click)="clearValue('tile_id');$event.stopImmediatePropagation()"
                  *ngIf="form.controls.tile_id.value" aria-label="Clear" mat-icon-button
                  matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <div fxFlex fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0px" fxLayoutGap.gt-xs="22px">
          <mat-form-field fxFlex="100" fxFlex.gt-xs="45" #f8 [matTooltip]="getTooltipText(f8)">
            <mat-label>X coördinaten</mat-label>
            <input matInput [formControl]="form.controls.new_rd_lat" placeholder="X coördinaten">
            <mat-error *ngIf="formService.getFieldError('new_rd_lat')">
              {{ formService.getFieldError('new_rd_lat') }}
            </mat-error>
            <button (click)="clearValue('new_rd_lat');$event.stopImmediatePropagation()"
                    *ngIf="form.controls.new_rd_lat.value" aria-label="Clear" mat-icon-button
                    matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field fxFlex="100" fxFlex.gt-xs="45" #f8 [matTooltip]="getTooltipText(f8)">
            <mat-label>Y coördinaten</mat-label>
            <input matInput [formControl]="form.controls.new_rd_lng" placeholder="Y coördinaten">
            <mat-error *ngIf="formService.getFieldError('number')">
              {{ formService.getFieldError('number') }}
            </mat-error>
            <button (click)="clearValue('new_rd_lng');$event.stopImmediatePropagation()"
                    *ngIf="form.controls.new_rd_lng.value" aria-label="Clear" mat-icon-button
                    matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div fxFlex="100" fxFlex.gt-xs="10">
            <button mat-icon-button matTooltip="Select location on the map">
              <mat-icon>add_location</mat-icon>
            </button>
          </div>
        </div>
        <mat-form-field #f10 [matTooltip]="getTooltipText(f10)">
          <mat-label>Adres</mat-label>
          <input [formControl]="form.controls.address" matInput placeholder="Adres">
          <mat-error *ngIf="formService.getFieldError('address')">
            {{ formService.getFieldError('address') }}
          </mat-error>
          <button (click)="clearValue('address');$event.stopImmediatePropagation()"
                  *ngIf="form.controls.address.value" aria-label="Clear" mat-icon-button
                  matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field #f13 [matTooltip]="getTooltipText(f13)">
          <mat-label>Bron</mat-label>
          <mat-select [formControl]="form.controls.source_id" placeholder="Bron">
            <mat-option *ngFor="let source of filters.sources.data" [value]="source.id">
              {{ source.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formService.getFieldError('source_id')">
            {{ formService.getFieldError('source_id') }}
          </mat-error>
          <mat-spinner *ngIf="filters.sources.isLoading" diameter="20"></mat-spinner>
          <button (click)="clearValue('source_id');$event.stopImmediatePropagation()"
                  *ngIf="form.controls.source_id.value" aria-label="Clear" mat-icon-button
                  matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field #f14 [matTooltip]="getTooltipText(f14)">
          <mat-label>Actie</mat-label>
          <mat-select [formControl]="form.controls.action_id" placeholder="Actie">
            <mat-option *ngFor="let action of filters.actions.data" [value]="action.id">
              {{ action.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formService.getFieldError('action_id')">
            {{ formService.getFieldError('action_id') }}
          </mat-error>
          <mat-spinner *ngIf="filters.actions.isLoading" diameter="20"></mat-spinner>
          <button (click)="clearValue('action_id');$event.stopImmediatePropagation()"
                  *ngIf="form.controls.action_id.value" aria-label="Clear" mat-icon-button
                  matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field #f15 [matTooltip]="getTooltipText(f15)">
          <mat-label>Strom</mat-label>
          <mat-select [formControl]="form.controls.current_id" placeholder="Strom">
            <mat-option *ngFor="let current of filters.currents.data" [value]="current.id">
              {{ current.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formService.getFieldError('current_id')">
            {{ formService.getFieldError('current_id') }}
          </mat-error>
          <mat-spinner *ngIf="filters.currents.isLoading" diameter="20"></mat-spinner>
          <button (click)="clearValue('current_id');$event.stopImmediatePropagation()"
                  *ngIf="form.controls.current_id.value" aria-label="Clear" mat-icon-button
                  matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field #f16 [matTooltip]="getTooltipText(f16)">
          <mat-label>Invloed registratie</mat-label>
          <mat-select [formControl]="form.controls.impact_registration_id" placeholder="Invloed registratie">
            <mat-option *ngFor="let imapctRegistration of filters.impactRegistrations.data" [value]="imapctRegistration.id">
              {{ imapctRegistration.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formService.getFieldError('impact_registration_id')">
            {{ formService.getFieldError('impact_registration_id') }}
          </mat-error>
          <mat-spinner *ngIf="filters.impactRegistrations.isLoading" diameter="20"></mat-spinner>
          <button (click)="clearValue('impact_registration_id');$event.stopImmediatePropagation()"
                  *ngIf="form.controls.impact_registration_id.value" aria-label="Clear" mat-icon-button
                  matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field #f17 [matTooltip]="getTooltipText(f17)">
          <mat-label>Zaak</mat-label>
          <input matInput [formControl]="form.controls.outside_number">
          <mat-error *ngIf="formService.getFieldError('outside_number')">
            {{ formService.getFieldError('outside_number') }}
          </mat-error>
          <button (click)="clearValue('outside_number');$event.stopImmediatePropagation()"
                  *ngIf="form.controls.outside_number.value" aria-label="Clear" mat-icon-button
                  matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="16px">
        <button (click)="close()" class="mat-secondary" fxFlex mat-raised-button type="button">
          <mat-icon>cancel</mat-icon>
          Verwijder filter
        </button>
        <button (click)="closeAndFilter()" fxFlex mat-raised-button type="button" color="primary">
          <mat-icon>filter_list</mat-icon>
          Toepassen
        </button>
      </div>
    </div>
  </div>
</form>
